import { apiRequest, apiResponse } from "@/shared/api/client";

/** 前端站点视图：永不暴露 cookie / token / apikey 原文 */
export interface SiteView {
  id: number;
  name: string;
  domain: string;
  url: string;
  pri: number;
  is_active: boolean;
  proxy: boolean;
  has_cookie: boolean;
  has_rss: boolean;
}

interface SiteRaw {
  id?: number | null;
  name?: string | null;
  domain?: string | null;
  url?: string | null;
  pri?: number | null;
  is_active?: boolean | null;
  proxy?: number | null;
  cookie?: string | null;
  rss?: string | null;
  token?: string | null;
  apikey?: string | null;
  ua?: string | null;
}

function toView(raw: SiteRaw): SiteView | null {
  if (raw.id == null) return null;
  return {
    id: raw.id,
    name: raw.name || raw.domain || `站点 #${raw.id}`,
    domain: raw.domain || "",
    url: raw.url || "",
    pri: raw.pri ?? 0,
    is_active: raw.is_active !== false,
    proxy: Boolean(raw.proxy),
    has_cookie: Boolean(raw.cookie && String(raw.cookie).trim()),
    has_rss: Boolean(raw.rss && String(raw.rss).trim()),
  };
}

export async function listSites(): Promise<SiteView[]> {
  const raw = await apiRequest<SiteRaw[]>("/api/v1/site/");
  return (Array.isArray(raw) ? raw : [])
    .map(toView)
    .filter((s): s is SiteView => s != null);
}

export function testSite(siteId: number) {
  if (!Number.isInteger(siteId) || siteId <= 0) {
    return Promise.reject(new Error("无效的站点 ID"));
  }
  return apiResponse(`/api/v1/site/test/${siteId}`);
}

export function syncCookieCloud() {
  return apiResponse("/api/v1/site/cookiecloud");
}
